import NavCard from './src/nav-card';

export default NavCard;
